/**
 * Rewards API client for claiming user rewards.
 */

import { BaseApiClient } from './base'
import type { UserReward } from '../../types'

export interface PendingRewardsResponse {
  rewards: UserReward[]
  count: number
}

export interface UserRewardsResponse {
  rewards: UserReward[]
}

export interface ClaimRewardResponse {
  success: boolean
  message: string
  reward_name?: string
  reward_type?: 'credits' | 'bonus_downloads'
  credit_amount?: number
  new_balance?: number
  bonus_download_amount?: number
  expires_at?: string
}

export class RewardsApi extends BaseApiClient {
  /**
   * Get all rewards for the current user
   */
  async getUserRewards(): Promise<UserRewardsResponse> {
    return this.request('/rewards')
  }

  /**
   * Get pending (claimable) rewards for the current user
   */
  async getPendingRewards(): Promise<PendingRewardsResponse> {
    return this.request('/rewards/pending')
  }

  /**
   * Claim a reward
   */
  async claimReward(userRewardId: number): Promise<ClaimRewardResponse> {
    return this.request(`/rewards/${userRewardId}/claim`, {
      method: 'POST',
    })
  }
}

